export const FeatureType = {
    Dashboard: "Dashboard",
    PlanVerification: "PlanVerification",
    PlanVerificationDocuments: "PlanVerificationDocuments",
    PlanVerificationCorrections: "PlanVerificationCorrections",
    PlanVerificationVerification: "PlanVerificationVerification",
    CreateMrvMonitoringPlan: "CreateMrvMonitoringPlan",
    CreateFuelEuMonitoringPlan: "CreateFuelEuMonitoringPlan",
    CreateSeemp2MonitoringPlan: "CreateSeemp2MonitoringPlan",
    CreateSeemp3MonitoringPlan: "CreateSeemp3MonitoringPlan",
    ViewMrvMonitoringPlan: "ViewMrvMonitoringPlan",
    ViewFuelEuMonitoringPlan: "ViewFuelEuMonitoringPlan",
    ViewSeemp2MonitoringPlan: "ViewSeemp2MonitoringPlan",
    ViewSeemp3MonitoringPlan: "ViewSeemp3MonitoringPlan",
    EmissionSourceType: "EmissionSourceType",
    SubmitToAbs: "SubmitToAbs",
    AddPlanVerification: "AddPlanVerification",
    SubmitToDocuments: "SubmitToDocuments",
    VerificationComplete: "VerificationComplete",
    AvailableToClient: "AvailableToClient",
    AssignPlanVerificationVerifier: "AssignPlanVerificationVerifier",
    RetainPlanVerification: "RetainPlanVerification",

    ViewSEEMPIIMonitoringPlanDocuments: "ViewSEEMPIIMonitoringPlanDocuments",
    ViewSEEMPIIIMonitoringPlanDocuments: "ViewSEEMPIIIMonitoringPlanDocuments",
    ViewMRVMonitoringPlanDocuments: "ViewMRVMonitoringPlanDocuments",
    ViewFEUMonitoringPlanDocuments: "ViewFEUMonitoringPlanDocuments",

    ViewSEEMPIIMonitoringPlanCorrections: "ViewSEEMPIIMonitoringPlanCorrections",
    ViewSEEMPIIIMonitoringPlanCorrections: "ViewSEEMPIIIMonitoringPlanCorrections",
    ViewMRVMonitoringPlanCorrections: "ViewMRVMonitoringPlanCorrections",
    ViewFEUMonitoringPlanCorrections: "ViewFEUMonitoringPlanCorrections",

    ViewSEEMPIIMonitoringPlanVerification: "ViewSEEMPIIMonitoringPlanVerification",
    ViewSEEMPIIIMonitoringPlanVerification: "ViewSEEMPIIIMonitoringPlanVerification",
    ViewMRVMonitoringPlanVerification: "ViewMRVMonitoringPlanVerification",
    ViewFEUMonitoringPlanVerification: "ViewFEUMonitoringPlanVerification",

    AdvantageVesselTemplate:"AdvantageVesselTemplate",
    AdvantageUnifiedImportReport: "AdvantageUnifiedImportReport",


    GisisSubmitVerification: "GisisSubmitVerification",
    WayPointSubmitVerification:"WayPointSubmitVerification",

    SEEMPIIClone : "SEEMPIIClone",
    SEEMPIIIClone : "SEEMPIIIClone",
    FEUClone : "FEUClone",
    MRVClone : "MRVClone",
    LegacyReports: "LegacyReports",

    ViewSupportVideoTutorials: "ViewSupportVideoTutorials",
    CreateSupportVideoTutorialSection: "CreateSupportVideoTutorialSection",
    EditSupportVideoTutorialSection: "EditSupportVideoTutorialSection",
    DeleteSupportVideoTutorialSection: "DeleteSupportVideoTutorialSection",
    CreateSupportVideoTutorial: "CreateSupportVideoTutorial",
    EditSupportVideoTutorial: "EditSupportVideoTutorial",
    DeleteSupportVideoTutorial: "DeleteSupportVideoTutorial",

    ViewSupportGuides: "ViewSupportGuides",
    CreateSupportGuide: "CreateSupportGuide",
    DownloadSupportGuide: "DownloadSupportGuide",
    EditSupportGuide: "EditSupportGuide",
    ToggleGuideVisibility: "ToggleGuideVisibility",
    DeleteSupportGuide: "DeleteSupportGuide",

    ViewSupportResources: "ViewSupportResources",
    CreateSupportResource: "CreateSupportResource",
    EditSupportResource: "EditSupportResource",
    ToggleResourceVisibility: "ToggleResourceVisibility",
    DeleteSupportResource: "DeleteSupportResource",

    ViewSupportContact: "ViewSupportContact",
    CreateSupportContact: "CreateSupportContact",
    EditSupportContact: "EditSupportContact",
    DeleteSupportContact: "DeleteSupportContact",

    ExportThetisXML: "ExportThetisXML",
    EnableContributionUserput : "EnableContributionUserput",
    ManagePortCodes: "ManagePortCodes",

    BulkExport: "BulkExport",
    FeuExport: "FeuExport",
    UkMrvExport: "UkMrvExport",
    ReportExport: "ParentReportExport",
    DcsExport: "DcsExport",
    EuMrvExport: "EuMrvExport",
    UKETSExport: "UKETSExport",

    ViewWebhookPanel: "WebhookPanel",

    Mis15DebugLogs: "Mis15DebugLogs",

    CiiCalculator: "CiiCalculator",
    ShowMisFilters: "ShowMisFilters",
    UnsatisfactoryCiiExport: "UnsatisfactoryCiiExport",
 
    SeempWaypointSubmission: "SeempWaypointSubmission",
}

export const FeatureToggleURLs = {
    IsFeatureEnabled: (featureName, wcn) => wcn ? `/api/FeatureToggle/${featureName}/enabled?wcn=${wcn}` : `/api/FeatureToggle/${featureName}/enabled`,
    CheckFeatures: '/api/FeatureToggle/check'
}